<template>
  <div class="heatmap-wrapper">
    <div id="cal-heatmap"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CalHeatMap from 'cal-heatmap';
import { heatmapLegendColors } from '@/mixins/colorConstants_live'; // eslint-disable-line

export default {
  name: 'AnalyticsHeatMap',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    range: {
      type: Array,
      default: () => [],
    },
  },
  beforeDestroy() {
    if (typeof this.heatMapCal !== 'undefined') {
      this.heatMapCal.destroy();
    }
  },
  computed: {
    ...mapState('analytics', ['selectedDate', 'selectedPeriod']),
  },
  watch: {
    data() {
      this.generateHeatMap();
    },
  },
  methods: {
    generateHeatMap() {
      if (this.heatMapCal) {
        this.heatMapCal.destroy();
      }

      const domainOptions = {
        year: {
          subDomain: 'x_month',
          rowLimit: 4,
          cellSize: 50,
          nextUnit: 'month',
        },
        month: { subDomain: 'x_day', nextUnit: 'day', cellSize: 30 },
        day: { subDomain: 'x_hour', cellSize: 35, nextUnit: 'hour' },
        hour: {
          subDomain: 'x_min',
          cellSize: 22,
          domainMargin: 5,
          nextUnit: 'hour',
        },
      };

      if (this.selectedPeriodselectedPeriod === 'week') domainOptions.month.nextUnit = 'day';

      const cleanData = {};
      Object.keys(this.data).forEach(key => {
        cleanData[key] = this.data[key];
      });

      const options = {
        data: cleanData,
        legend: this.range,
        domain: this.selectedPeriod,
        start: this.selectedDate.toDate(),
        cellSize: 17,
        cellRadius: 0,
        cellPadding: 1,
        range: 1,
        domainDynamicDimension: false,
        animationDuration: 0,
        legendColors: heatmapLegendColors,
        displayLegend: false,
        domainLabelFormat: '',
        onClick: date => {
          const nextPeriod = domainOptions[this.selectedPeriod].nextUnit;
          this.$emit('onChangeDate', { date, period: nextPeriod });
        },
        afterLoadData: timestamps => {
          const offset = new Date().getTimezoneOffset() * 60;
          const results = {};
          Object.keys(timestamps).forEach(timestamp => {
            const total = timestamps[timestamp];
            results[parseInt(timestamp, 10) + offset] = total;
          });
          return results;
        },
      };

      // Assign domain / period specific options
      const unit = this.selectedPeriod;
      const selectedDomainOptions = domainOptions[unit];
      Object.keys(selectedDomainOptions).forEach(key => {
        options[key] = selectedDomainOptions[key];
      });

      this.heatMapCal = new CalHeatMap();
      this.heatMapCal.init(options);
    },
  },
};
</script>

<style src="cal-heatmap/cal-heatmap.css"></style>
<style>
.heatmap-wrapper {
  margin-top: 6px;
}
.cal-heatmap-container {
  margin: auto;
}
.no-chart-data {
  font-size: 1.5em;
  color: lightgray;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// AnalyticsHeatMap.vue?d050439c